import {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import type { BraillerInventoryItemDto } from '../brailler.types';
import {PageTitle} from "../../../../Components/Landmarks";
import {locations} from "../../../../Utilities/Location";
import {allow} from "../../../../Components/Authorize";
import {emptyGuid} from "../../../../Utilities/commonUtilities";
import {braillerCatalogApi} from "../BraillerCatalog/braillerCatalogApi";
import {
    braillerCatalogItemModel,
    emptyBraillerCatalogItemModel,
} from "./braillerCatalogItemFactory";
import {BraillerCatalogItemView} from "./BraillerCatalogItemView";
import {MANAGE_BRAILLER_CATALOG} from "../../../../Components/Authorize/policyEventsConstants";

export const BraillerCatalogItemContainer = ({
                                                 catalogItemId,
                                                 handleApiCall,
                                                 redirect,
                                             }: ContextProps) => {

    const [catalogItem, setCatalogItem] = useState<Record<string, unknown> | null>(null);
    const [inventoryItems, setInventoryItems] = useState<BraillerInventoryItemDto[]>([]);

    const isEdit = catalogItemId && catalogItemId !== emptyGuid;
    const canManageCatalog = allow(MANAGE_BRAILLER_CATALOG);

    const loadBraillerCatalogItemResult = (result: Record<string, any>) => {
        setCatalogItem(braillerCatalogItemModel(result));
        setInventoryItems(result.inventoryItems || []);
    };

    const handleCancel = () => {
        redirect(locations.BRAILLER_CATALOG.path);
    };


    const handleSave = (catalogItemToSave: Record<string, unknown>) => {
        if(isEdit)
            handleApiCall(
                () => braillerCatalogApi.updateBraillerCatalogItemWithInventory(catalogItemToSave),
                () => redirect(locations.BRAILLER_CATALOG.path)
            );
        else
            handleApiCall(
                () => braillerCatalogApi.addBraillerCatalogItemWithInventory(catalogItemToSave),
                () => redirect(locations.BRAILLER_CATALOG.path)
            );
    }

    useEffect(() => {

        const newBraillerCatalogItem = {...emptyBraillerCatalogItemModel}

        const getBraillerCatalogItem = () => {
            handleApiCall(() => braillerCatalogApi.getBraillerCatalogItem(catalogItemId), (results = newBraillerCatalogItem) => loadBraillerCatalogItemResult(results));
        }

        if (isEdit && !catalogItem)
            getBraillerCatalogItem();
        else
            setCatalogItem(newBraillerCatalogItem);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [catalogItemId]);



    if (!catalogItem) return <></>;

    return (
        <>
            <PageTitle h1={!isEdit ? "Add Brailler Item" : "Edit Brailler Item"}/>

            <BraillerCatalogItemView
                canManageCatalog={canManageCatalog}
                handleSaveBraillerCatalogItem={handleSave}
                handleReturn={handleCancel}
                braillerCatalogItem={catalogItem}
                inventoryItems={inventoryItems}
                onInventoryChange={setInventoryItems}
            />
        </>
    );
};

